module.exports = __webpack_public_path__ + "static/media/Artboard13.f0140a9a.png";